// extracted by mini-css-extract-plugin
export default {"AdminSettings":"dark__AdminSettings___A+AkG undefined"};